<template>
  <div
    class="pb-2"
    style="padding-top: 3px;">
    <sForm
      ref="stageForm"
      class="stage-title__edit"
      label-position="top"
      :model="valueMutable"
      :rules="rules"
      @click.stop>
      <sFormItem
        :key="`stage-${index}-title`"
        :label="$t('Tenders.eventProp.title')"
        prop="title">
        <sInput
          class="stage-title__input"
          :data-qa="`${dataQa}-item-${index}-block-title_input`"
          :disabled="disabled"
          size="small"
          trim
          :value="valueMutable.title"
          @update:value="val => setValueMutable('title', val)"/>
      </sFormItem>
      <sFormItem
        :key="`stage-${index}-status`"
        :label="$t('Tenders.eventProp.type')"
        prop="type">
        <sSelect
          :ref="`type-select-${index}`"
          class="stage-type__select width-50"
          :data-qa="`${dataQa}-item-${index}-block-type_select`"
          :disabled="disabled"
          size="small"
          :value="valueMutable.type"
          @update:value="val => setValueMutable('type', val)">
          <sOption
            v-for="type in Object.values(typeStage)"
            :key="`type-${type.key}`"
            :data-qa="`${dataQa}-item-${index}-block-type_select-${type.key}`"
            :label="$t(`Tenders.AgreementTypes.${type.key}`)"
            :value="type.key"/>
        </sSelect>
      </sFormItem>
      <sFormItem 
        v-if="valueMutable.type === 'QUORUM'"
        :key="`stage-${index}-quorum`"
        :label="$t('Tenders.eventProp.countToQuorum')"
        prop="quorumCount">
        <sInputNumber
          :ref="`quorumCount-input-${index}`"
          class="stage-quorumCount__input width-50"
          :data-qa="`${dataQa}-item-${index}-block-quorumCount_input`"
          :disabled="disabled"
          :max="value.agreements?.filter(i => i.contactId)?.length || 0"
          size="small"
          :value="valueMutable.quorumCount"
          @update:value="val => setValueMutable('quorumCount', val)"/>
      </sFormItem>
    </sForm>
    <div class="flex gap-20 vertical-align-center mt-2">
      <sButton
        :data-qa="`${dataQa}-item-${index}-block-title_btn-accept`"
        :disabled="disabled"
        icon="accept"
        small
        @click.stop="validateForm">
        Зберегти
      </sButton>
      <sButton
        :data-qa="`${dataQa}-item-${index}-block-title_btn-cancel`"
        :disabled="disabled"
        icon="cross"
        small
        type="text"
        @click.stop="$emit('set-state', false)">
        Скасувати
      </sButton>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StageAdditionalAgreementFormEdit',
  data() {
    const that = this
    return {
      typeStage: {
        PARALLEL: {key: 'PARALLEL', icon: 'column'},
        CONSISTENTLY: {key: 'CONSISTENTLY', icon: 'column', iconClass: 's-svg-icon-rotate-90'},
        QUORUM: {key: 'QUORUM', icon: 'persons'},
      },
      rules: {
        title: {
          type: 'string',
          trigger: 'change',
          required: true,
          message: that.$t('Tenders.EnterStageTitle')
        },
        type: {
          type: 'string',
          trigger: 'change',
          required: true,
          message: that.$t('Validate.Required')
        },
        quorumCount: {
          type: 'number',
          trigger: 'change',
          validator(rule, value, callback) {
            if (that.valueMutable.type === 'QUORUM') {
              if (!value) {
                callback(new Error(that.$t('Validate.Required')))
              }
              if (value > that.value.agreements?.filter(i => i.contactId)?.length) {
                callback(new Error(that.$t('Не повинно бути більше кількості погоджувачів')))
              }
              callback()
            } else {
              callback()
            }
          }
        }
      }
    }
  },
  methods: {
    validateForm() {
      this.$refs.stageForm.validate((valid) => {
        if (valid) {
          if (this.valueMutable.type !== 'QUORUM') {
            this.valueMutable = { ...this.valueMutable, quorumCount: null }
          }
          this.$emit('set-state', true)
        }
      })
    },
    setValueMutable(prop, value) {
      this.valueMutable = {
        ...this.valueMutable,
        [prop]: value
      }
    },
  },
  computed: {
    valueMutable: {
      get() {
        return this.value?.editObject ?? {}
      },
      set(val) {
        this.$emit('update:value', { ...this.value, editObject: val })
      }
    },
  },
  components: {},
  created() {},
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
    },
    disabled: Boolean,
    dataQa: String
  },
}
</script>
<style scoped lang="scss">
</style>
